/**
 * <dark-fomo-strip>
 *
 * Ürün ID'si + günlük tarih seed'iyle deterministik pseudo-random sayılar
 * üretir; her ürün için sabit görünür ama günden güne hafifçe değişir.
 * Mesajlar dikey scroll ile döner.
 */

const SEED_OFFSET = 0x9e3779b9;

function hashSeed(...parts) {
  let h = 0x811c9dc5;
  const str = parts.join('|');
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return (h ^ SEED_OFFSET) >>> 0;
}

function mulberry32(seed) {
  let state = seed >>> 0;
  return function () {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function pickInRange(rng, min, max) {
  if (max <= min) return min;
  return min + Math.floor(rng() * (max - min + 1));
}

class DarkFomoStrip extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-fomo-list]');
    if (!this.list) return;
    this.items = Array.from(this.list.querySelectorAll('.dark-fomo__item'));
    if (!this.items.length) return;

    this.populateNumbers();

    if (this.items.length > 1) {
      this.activeIndex = 0;
      this.scheduleRotation();
      this.addEventListener('mouseenter', this.pause);
      this.addEventListener('mouseleave', this.resume);
      document.addEventListener('visibilitychange', this.handleVisibility);
    }
  }

  disconnectedCallback() {
    this.clearTimer();
    this.removeEventListener('mouseenter', this.pause);
    this.removeEventListener('mouseleave', this.resume);
    document.removeEventListener('visibilitychange', this.handleVisibility);
  }

  populateNumbers() {
    const productId = this.dataset.productId || '0';
    const today = new Date();
    const daySeed = `${today.getUTCFullYear()}-${today.getUTCMonth()}-${today.getUTCDate()}`;

    this.items.forEach((item) => {
      const kind = item.dataset.fomoKind;
      const textEl = item.querySelector('[data-fomo-template]');
      if (!textEl) return;

      const template = textEl.dataset.fomoTemplate || '';
      const min = Number.parseInt(this.dataset[`${kind}Min`] || '0', 10);
      const max = Number.parseInt(this.dataset[`${kind}Max`] || '0', 10);

      const seed = hashSeed(productId, kind, daySeed);
      const rng = mulberry32(seed);
      const count = pickInRange(rng, min, max);

      const html = template.replace('{count}', `<strong>${count}</strong>`);
      textEl.innerHTML = html;
    });
  }

  scheduleRotation = () => {
    const seconds = Number.parseFloat(this.dataset.rotationSeconds || '5');
    const interval = Math.max(2, seconds) * 1000;
    this.timer = window.setInterval(this.advance, interval);
  };

  advance = () => {
    if (!this.list || !this.items.length) return;
    this.activeIndex = (this.activeIndex + 1) % this.items.length;
    const offset = this.activeIndex * this.items[0].offsetHeight;
    this.list.style.transform = `translateY(-${offset}px)`;
  };

  pause = () => this.clearTimer();

  resume = () => {
    if (!this.timer && this.items.length > 1) {
      this.scheduleRotation();
    }
  };

  handleVisibility = () => {
    if (document.hidden) {
      this.pause();
    } else {
      this.resume();
    }
  };

  clearTimer() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
}

if (!customElements.get('dark-fomo-strip')) {
  customElements.define('dark-fomo-strip', DarkFomoStrip);
}
